import { inject, Injectable} from '@angular/core';
import { UserService} from "./user.service";
import {ApartmentService} from "./apartment.service";
import {isUserEligibleForApartment} from "../model/lottery";
import {NotificationService} from "./notification/notification.service";
import {
  EligibilityChangesDialogComponent
} from "../pages/profile-tab/profile-tab-active-user-page/eligibility-changes-dialog/eligibility-changes-dialog.component";
import {AutoApplyAfterProfileUpdateLotteriesDialogContentComponent} from "./notification/notification-dialog-content/auto-apply-after-profile-update-lotteries-dialog-content/auto-apply-after-profile-update-lotteries-dialog-content.component";
import {firstValueFrom} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class NewLotteriesAfterUserUpdateService {
  private readonly userService = inject(UserService);
  private readonly apartmentService = inject(ApartmentService);
  private readonly notificationService = inject(NotificationService);
  private eligibleLotteries: string[] | undefined = undefined

  public storeOldData() {
    const user = this.userService.user();

    if (user?.status === 'active') {
      this.eligibleLotteries = this.apartmentService.openLotteries()?.filter(
        (apartment) => isUserEligibleForApartment(
          apartment,
          this.userService.user()
        )
      )?.map(
        apartment => apartment.id
      ) ?? [];
    }
  }

  public async checkForNewLotteries() {
    const user = this.userService.user();
    if (user?.status !== 'active' || this.eligibleLotteries === undefined) {
      return;
    }

    const currentEligibleLotteries = this.eligibleLotteries;
    this.eligibleLotteries = undefined;

    if (user.autoApplySettings.enabled) {
      const autoAppliedLotteries = await firstValueFrom(this.userService.refreshAutoApply());

      if (autoAppliedLotteries.length > 0) {
        this.notificationService.openNotificationDialog(
          [{
            component: AutoApplyAfterProfileUpdateLotteriesDialogContentComponent,
            data: {
              lotteries: autoAppliedLotteries
            }
          }]
        );
      }
    } else {
      const newEligibleLotteries = (this.apartmentService.openLotteries() ?? []).filter(
        (apartment) => isUserEligibleForApartment(
          apartment,
          user
        )
      ).map(
        app => app.id
      );

      const newUniqueIds = newEligibleLotteries.filter(
        id => !currentEligibleLotteries.includes(id)
      );

      if (newUniqueIds.length === 0) {
        return;
      }

      this.notificationService.openNotificationDialog(
        [
          {
            component: EligibilityChangesDialogComponent,
            data: {
              lotteries: newUniqueIds
            }
          }]
      )
    }
  }
}
